<template>
  <div id="ec-steps" :class="stepClass">
    <component :is="stepComponent" :step="step" />
  </div>
</template>
<script>
import Step1 from '@/components/Step-1'
import Step2 from '@/components/Step-2'
import Step3 from '@/components/Step-3'
import Step4 from '@/components/Step-4'
import Step5 from '@/components/Step-5'
import Step6 from '@/components/Step-6'
import Step7 from '@/components/Step-7'
import Step8 from '@/components/Step-8'

export default {
  props: {
    step: {
      required: true
    }
  },
  components: {
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    Step6,
    Step7,
    Step8
  },
  computed: {
    stepClass () {
      return 'step-' + this.step
    },
    stepComponent () {
      return 'Step' + this.step
    }
  },
  data () {
    return {

    }
  },
  methods: {}
}
</script>
<style lang="scss">
@import "./../assets/scss/variables";
@import "./../assets/scss/mixins";

#ec-steps {
  background-color: #fff;
  color: $dark;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 100%;
  overflow: scroll;
  font-family: $font-family-sans;

  @include respond-above(lg) {
    overflow: hidden;
  }

  .step {
    margin: 1rem;
    flex-grow: 1;
    width: 100%;

    @include respond-above(lg) {
      overflow: hidden;
      // width: 90%;
    }
  }

  @include respond-above(lg) {
    min-height: 650px;
    //display: block;

    .step {
      //min-height: 440px;
    }
  }
}
</style>
